import { FC, Fragment } from 'react'
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'
import { Divider, Drawer, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { isDebug, moduleName } from '../configs'
import routes, { AppRoute } from '../Routes'

import { useSessionContext, StudentContextProvider } from '../contexts'

import { AppMenu } from './appmenu'
import { Header, TopBar } from '.'

const Main: FC = () => {
    const classes = useStyles()
    const { user } = useSessionContext()

    if (!user) return <></>
    return (
        <Router>
            <StudentContextProvider>
                <div className={classes.root}>
                    <Drawer variant={'permanent'} classes={{ paper: classes.drawerPaper, }}>
                        <Header moduleName={moduleName} />
                        <Divider />
                        <AppMenu />
                    </Drawer>
                    <main className={classes.content}>
                        <Switch>
                            {
                                routes.map(({ path, Component, exact, debugOnly = false }: AppRoute, key) =>
                                    ((isDebug && debugOnly) || !debugOnly)
                                        ? (
                                            <Route
                                                exact={exact}
                                                path={path}
                                                key={'rt' + key}
                                                render={props => {
                                                    const crumbs = routes
                                                        // Get all routes that contain the current one.
                                                        .filter(({ path }) => props.match.path.includes(path))
                                                        // Swap out any dynamic routes with their param values.                                                        
                                                        .map(({ path, ...rest }) => ({
                                                            path: Object.keys(props.match.params).length
                                                                ? Object.keys(props.match.params).reduce((path, param) => path.replace(`:${param}`, props.match.params[param]!), path)
                                                                : path,
                                                            ...rest
                                                        }))

                                                    //crumbs.map(({ name, path }) => console.log({ name, path }))

                                                    return (
                                                        <>
                                                            <TopBar crumbs={crumbs} />
                                                            <Container className={classes.container}>
                                                                <Component />
                                                            </Container>
                                                        </>
                                                    )
                                                }}
                                            />
                                        )
                                        : <Fragment key={'rt' + key} />
                                )}
                        </Switch>
                    </main>
                </div>
            </StudentContextProvider>

        </Router>
    )
}

export const drawerWidth = 325

export const useStyles = makeStyles(theme => ({
    root: {
        overflow: 'hidden',
        flexGrow: 1,
    },
    drawerPaper: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        borderRight: '0',
        width: drawerWidth,
        paddingBottom: theme.spacing(4),
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    content: {
        marginTop: '64px',
        marginLeft: drawerWidth,
        overflow: 'auto',
        backgroundColor: theme.palette.background.default
    },
    container: {
        padding: theme.spacing(0, 3, 4, 3),
    }

}))

export default Main
